module.exports = __webpack_public_path__ + "static/media/cartao-verso.c6f5d9da.png";